module.exports = __webpack_public_path__ + "media/home-page-video.0a6c007d.mp4";